import { Component, ContentChild, Directive, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { TermsOfServiceDialogComponent } from '../../../shared/terms-of-service-dialog/terms-of-service-dialog.component';
import { MatDialogSizes } from '../../../../enums/mat-dialog-sizes.enum';
import { PrivacyPolicyDialogComponent } from '../../../shared/privacy-policy-dialog/privacy-policy-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { GrowlerService } from '../../../../services/growler.service';
import { LegFiJwtService } from '../../../../services/auth/legfi-jwt.service';
import moment from 'moment-timezone';

@Directive({
    selector: '[signupForm]',
})
export class SignUpFormDirective
{
    constructor(public templateRef: TemplateRef<unknown>) {
    }
}

@Directive({
    selector: '[signupStep]',
})
export class SignUpStepDirective
{
    constructor(public templateRef: TemplateRef<unknown>) {
    }
}

@Directive({
    selector: '[signupSubtext]',
})
export class SignUpSubtextDirective
{
    constructor(public templateRef: TemplateRef<unknown>) {
    }
}

@Component({
    selector: 'app-sign-up-container',
    templateUrl: './sign-up-container.component.html',
    styleUrls: ['../../auth-layout-shared-styles.scss'],
})
export class SignUpContainerComponent implements OnInit
{
    @Input() formGroup: FormGroup;
    @Input() isSubmitting = false;
    @Input() isHomeowner = false;
    @Input() largeContainer = false;

    @Output() onSubmit = new EventEmitter<FormGroup>();

    @ContentChild(SignUpFormDirective) signupForm!: SignUpFormDirective;
    @ContentChild(SignUpStepDirective) signupStep!: SignUpStepDirective;
    @ContentChild(SignUpSubtextDirective) signupSubtext!: SignUpSubtextDirective;

    constructor(
        private _dialog: MatDialog,
        private _growler: GrowlerService,
    ) {
    }

    get copyrightYear() {
        return `©${moment().year()} PayHOA, LLC. All rights reserved.`;
    }

    ngOnInit() {
        if (LegFiJwtService.raw() === 'false') {
            LegFiJwtService.clear();
        }
    }

    submit() {
        if (this.formGroup.valid) {
            this.isSubmitting = true;
            this.onSubmit.emit(this.formGroup);
        } else {
            this.validateAllFormFields(this.formGroup);
            this._growler.error('Error', 'Please check all required fields.');
        }
    }

    openTermsOfService() {
        this._dialog.open(TermsOfServiceDialogComponent, {
            width: MatDialogSizes.MD,
        });
    }

    openPrivacyPolicy() {
        this._dialog.open(PrivacyPolicyDialogComponent, {
            width: MatDialogSizes.MD,
        });
    }

    private validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }
}
